export const MAGIC_LINK_TTL_MINUTES = 5;
export const RESEND_COOLDOWN_SECONDS = 30;
export const IDLE_TIMEOUT_MINUTES = 30;
export const SESSION_MAX_AGE_HOURS = 12;
export const RECOVERY_CODE_PATTERN = /^[A-Za-z0-9]{4}-?[A-Za-z0-9]{4}$/;
export const RECOVERY_CODES_LOW_THRESHOLD = 2;
export const TWO_FACTOR_CODE_LENGTH = 6;
export const TWO_FACTOR_CODE_PATTERN = new RegExp(`^\\d{${TWO_FACTOR_CODE_LENGTH}}$`);
export const PASSWORD_MAX_LENGTH = 128;
export const PHONE_NUMBER_INPUT_MAX_LENGTH = 24;
